export class IHash<T> {
  [details: string]: T;
}

export function isIHashEmpty<T>(hash: IHash<T>): boolean {
  return Object.keys(hash).length === 0;
}
